import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Gift, User, Phone, MapPin } from 'lucide-react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
interface GiftingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (details: {
    recipientName: string;
    recipientPhone: string;
    deliveryAddress: string;
    isGift: boolean;
  }) => void;
  productName: string;
}
export function GiftingModal({
  isOpen,
  onClose,
  onConfirm,
  productName
}: GiftingModalProps) {
  const [isGift, setIsGift] = useState<boolean | null>(null);
  const [recipientName, setRecipientName] = useState('');
  const [recipientPhone, setRecipientPhone] = useState('');
  const [deliveryAddress, setDeliveryAddress] = useState('');
  const handleConfirm = () => {
    if (isGift === false) {
      // Buying for myself
      onConfirm({
        recipientName: '',
        recipientPhone: '',
        deliveryAddress: '',
        isGift: false
      });
    } else {
      // Gifting
      if (!recipientName || !recipientPhone || !deliveryAddress) return;
      onConfirm({
        recipientName,
        recipientPhone,
        deliveryAddress,
        isGift: true
      });
    }
    onClose();
  };
  return <AnimatePresence data-id="element-573">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" data-id="element-574">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.95
      }} className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden" data-id="element-575">
            <div className="p-6 border-b border-gray-100 flex justify-between items-center bg-rose-50/30" data-id="element-576">
              <h3 className="text-xl font-serif font-bold text-gray-900" data-id="element-577">
                Who is this for?
              </h3>
              <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-578">
                <X size={20} data-id="element-579" />
              </button>
            </div>

            <div className="p-6 space-y-6" data-id="element-580">
              <p className="text-gray-600" data-id="element-581">
                You are customizing:{' '}
                <span className="font-semibold text-gray-900" data-id="element-582">
                  {productName}
                </span>
              </p>

              {isGift === null ? <div className="grid grid-cols-2 gap-4" data-id="element-583">
                  <button onClick={() => setIsGift(false)} className="flex flex-col items-center justify-center p-6 border-2 border-gray-200 rounded-xl hover:border-rose-500 hover:bg-rose-50 transition-all group" data-id="element-584">
                    <User className="w-8 h-8 text-gray-400 group-hover:text-rose-500 mb-3" data-id="element-585" />
                    <span className="font-semibold text-gray-900" data-id="element-586">Myself</span>
                  </button>
                  <button onClick={() => setIsGift(true)} className="flex flex-col items-center justify-center p-6 border-2 border-gray-200 rounded-xl hover:border-rose-500 hover:bg-rose-50 transition-all group" data-id="element-587">
                    <Gift className="w-8 h-8 text-gray-400 group-hover:text-rose-500 mb-3" data-id="element-588" />
                    <span className="font-semibold text-gray-900" data-id="element-589">A Gift</span>
                  </button>
                </div> : isGift ? <div className="space-y-4" data-id="element-590">
                  <div className="flex items-center gap-2 text-rose-600 mb-2" data-id="element-591">
                    <Gift className="w-5 h-5" data-id="element-592" />
                    <span className="font-medium" data-id="element-593">Enter Recipient Details</span>
                  </div>

                  <Input label="Recipient Name" value={recipientName} onChange={e => setRecipientName(e.target.value)} placeholder="Who is this gift for?" required data-id="element-594" />

                  <Input label="Recipient Phone" value={recipientPhone} onChange={e => setRecipientPhone(e.target.value)} placeholder="Their contact number" required data-id="element-595" />

                  <Input label="Delivery Address" value={deliveryAddress} onChange={e => setDeliveryAddress(e.target.value)} placeholder="Where should we deliver it?" required data-id="element-596" />

                  <div className="flex gap-3 pt-4" data-id="element-597">
                    <Button variant="outline" onClick={() => setIsGift(null)} className="flex-1" data-id="element-598">
                      Back
                    </Button>
                    <Button onClick={handleConfirm} disabled={!recipientName || !recipientPhone || !deliveryAddress} className="flex-1" data-id="element-599">
                      Confirm Details
                    </Button>
                  </div>
                </div> : <div className="text-center py-8" data-id="element-600">
                  <div className="w-16 h-16 bg-rose-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-601">
                    <User className="w-8 h-8 text-rose-500" data-id="element-602" />
                  </div>
                  <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-603">
                    Treating Yourself?
                  </h4>
                  <p className="text-gray-600 mb-6" data-id="element-604">
                    Great! We'll use your default delivery details for this
                    item.
                  </p>
                  <div className="flex gap-3" data-id="element-605">
                    <Button variant="outline" onClick={() => setIsGift(null)} className="flex-1" data-id="element-606">
                      Back
                    </Button>
                    <Button onClick={handleConfirm} className="flex-1" data-id="element-607">
                      Confirm
                    </Button>
                  </div>
                </div>}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}